<div class="newAssetSitePickerAccount" (click)="toggleExpand()">
  <pp-icon
    [ppSrc]="expanded ? EIconPath.ICON_MISC_DOWN_CHEVRON_24 : EIconPath.ICON_MISC_RIGHT_CHEVRON_24"
    ppClass="setSize24"
    ppColor="inherit"
  ></pp-icon>

  {{ ppAccount.accountName }}
</div>

@if (expanded) {
  @for (workspaceId of ppAccount.workspaces; track workspaceId) {
    <pp-new-asset-site-picker-workspace
      [ppWorkspaceId]="workspaceId"
    ></pp-new-asset-site-picker-workspace>
  }
}
